import React from 'react';
import { ICartItem } from '../../../interfaces';
import InfoIcon from '../../../../../../ui/svg/common/info';
import Tooltip from '../../../../../../ui/tooltip/tooltip';

interface ICartItemBonus {
    cartItem: ICartItem,
    classes?: string,
}
const CartItemBonus = (props: ICartItemBonus) => {

    const cartItem = props.cartItem;

    return (
        cartItem.bonusWCSCredits ?
            <div className={ `flex items-center text-green mb-2 ${ props.classes ? props.classes : '' }` }>
                <span className="mr-2">+{ cartItem.bonusWCSCredits } credits welcome bonus</span>

                <Tooltip
                    width={ '250px' }
                    buttonText=""
                    buttonClasses="flex"
                    buttonHtml={
                        <InfoIcon width="15px" color="#0EC0A3"/>
                    }>
                    The bonus is given only once per user, on your first-ever ILLUGEN plan.
                </Tooltip>

            </div> : <></>
    )
};

export default CartItemBonus;